function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Menu, Button, Descriptions, Divider } from "antd";
import { MegaphoneFill, DoorOpenFill, GeoAltFill, PlayCircleFill, PersonCheck, TicketPerforatedFill, CalendarEventFill, Link as LinkIcon, QuestionSquareFill, HouseFill, GearFill, Power } from 'react-bootstrap-icons';
import { Container, Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom';
import axios from 'axios';
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var AccountNav = function AccountNav() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOut = _useState2[0],
    setIsOut = _useState2[1];
  var handleClick = function handleClick(e) {
    if (e.key == 'leave') {
      var fd = new FormData();
      axios.post(Common.baseApiUrl + 'logout', fd).then(function (result) {
        localStorage.removeItem('userData');
        localStorage.clear();
        setIsOut(true);
        window.location.replace('/');
      });
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "mobile-nav-item",
            children: /*#__PURE__*/_jsxs(Link, {
              to: "/home",
              children: [/*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(HouseFill, {
                  size: 22
                })
              }), /*#__PURE__*/_jsx("b", {
                children: "Accueil"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "mobile-nav-item",
            children: /*#__PURE__*/_jsxs(Link, {
              to: "/home/events",
              children: [/*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(CalendarEventFill, {
                  size: 22
                })
              }), /*#__PURE__*/_jsx("b", {
                children: "Ev\xE8nements"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "mobile-nav-item",
            children: /*#__PURE__*/_jsxs(Link, {
              to: "/home/medias",
              children: [/*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(PlayCircleFill, {
                  size: 22
                })
              }), /*#__PURE__*/_jsx("b", {
                children: "Biblioth\xE8que"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "mobile-nav-item",
            children: /*#__PURE__*/_jsxs(Link, {
              to: "/home/map",
              children: [/*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(GeoAltFill, {
                  size: 22
                })
              }), /*#__PURE__*/_jsx("b", {
                children: "Carte"
              })]
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Divider, {}), Common.isOn == 'true' && /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "mobile-nav-item",
            children: /*#__PURE__*/_jsxs(Link, {
              to: "/compte/profil",
              children: [/*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(PersonCheck, {
                  size: 22
                })
              }), /*#__PURE__*/_jsx("b", {
                children: "Mon profil"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "mobile-nav-item",
            children: /*#__PURE__*/_jsxs(Link, {
              to: "/home/account/tickets",
              children: [/*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(TicketPerforatedFill, {
                  size: 22
                })
              }), /*#__PURE__*/_jsx("b", {
                children: "Mes Tickets"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "mobile-nav-item",
            children: /*#__PURE__*/_jsxs(Link, {
              to: "/home/account/events",
              children: [/*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(CalendarEventFill, {
                  size: 22
                })
              }), /*#__PURE__*/_jsx("b", {
                children: "Mes Ev\xE8nements"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "mobile-nav-item"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Menu, {
      style: {
        width: '260px'
      },
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Power, {
          size: 15
        }),
        children: "Se deconnecter"
      }, "leave")
    })]
  });
};
export default AccountNav;